<script lang="ts">
  import { EventTracking } from "@shared/services/event_tracking/events";
  import Header from "@onboarding2/svelte/Shared/Header.svelte";
  import Info from "@onboarding2/svelte/Signup/Info.svelte";
  import RetailerSelected from "@onboarding2/svelte/RetailerDetails/RetailerSelected.svelte";
  import SevenFiftyInfo from "@onboarding2/svelte/Signup/SevenFiftyInfo.svelte";
  import type { RetailerType } from "@shared/types/Retailer";
  import SalesforceChat from "@shared/services/salesforce_chat";

  export let referralData: {
    retailer: RetailerType;
    referralName?: string;
    referralDistributorName?: string;
  };

  const { trackClick, immediatelyProcessEventQueue } = EventTracking;

  const isSevenFiftyUser = referralData.retailer.partner_source === "seven_fifty";

  const hasInviterInformation = !!(
    referralData.referralName && referralData.referralDistributorName
  );

  const confirmActionWrapper = async (): Promise<void> => {
    trackClick("onboarding_confirm_business");
    await immediatelyProcessEventQueue();
    window.location.reload();
  };

  const openChat = () => {
    trackClick("open_support_chat");
    SalesforceChat.open();
  };
</script>

<style>
  div[data-grid-area="main"] > div {
    padding: 2rem 1.5rem;
  }

  @media (min-width: 1175px) {
    div[data-grid-area="main"] > div {
      padding: 3rem 4rem;
    }
  }
</style>

<div class="fizz-layout-header-50-50" style="min-height: 100vh;">
  <Header
    displayLogInOption={false}
    hideTitleOnMobile={true}
    title={"Bars, restaurants and retailers"}
    {isSevenFiftyUser}
  />
  {#if isSevenFiftyUser}
    <SevenFiftyInfo />
  {:else}
    <Info />
  {/if}
  <div data-grid-area="main" style="background: #F5F7F7">
    <div class="fizz-surface fizz-radius-medium fizz-elevation-1">
      <header class="fizz-text-center fizz-stack-8">
        <h3 class="fizz-heading-3">Confirm your business</h3>
      </header>
      <section class="fizz-stack-32">
        <p>
          {#if hasInviterInformation}
            <span class="fizz-text-strong">{referralData.referralName}</span> from
            {referralData.referralDistributorName} invited you to start ordering for
            <span class="fizz-text-strong">{referralData.retailer.name}</span> on Provi! Confirm your
            business address to get started.
          {:else}
            You've been invited to start ordering for
            <span class="fizz-text-strong">{referralData.retailer.name}</span>
            on Provi. Confirm your business address to get started.
          {/if}
        </p>
      </section>
      <section class="fizz-stack-32">
        <RetailerSelected showUnselect={false} retailer={referralData.retailer} />
      </section>
      <section>
        <div class="fizz-flex-row fizz-stack-32">
          <button
            class="fizz-button-secondary fizz-full-width fizz-button-large"
            on:click={confirmActionWrapper}
          >
            Confirm business
          </button>
        </div>
        <div class="fizz-flex-row fizz-justify-center fizz-subdued fizz-text-small">
          <span class="fizz-inline-4">Not your business?</span>
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <span class="fizz-link fizz-text-strong" on:click={openChat}>Chat with us</span>
        </div>
      </section>
    </div>
  </div>
</div>
